var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 16.8337C4.39765 16.8337 0.666687 13.1027 0.666687 8.50033C0.666687 3.89795 4.39765 0.166992 9.00002 0.166992C13.6024 0.166992 17.3334 3.89795 17.3334 8.50033C17.3334 13.1027 13.6024 16.8337 9.00002 16.8337ZM9.00002 15.167C12.6819 15.167 15.6667 12.1822 15.6667 8.50033C15.6667 4.81843 12.6819 1.83366 9.00002 1.83366C5.31812 1.83366 2.33335 4.81843 2.33335 8.50033C2.33335 12.1822 5.31812 15.167 9.00002 15.167ZM8.16669 11.0003H9.83335V12.667H8.16669V11.0003ZM9.83335 9.62957V10.167H8.16669V8.91699C8.16669 8.45674 8.53977 8.08366 9.00002 8.08366C9.69035 8.08366 10.25 7.52399 10.25 6.83366C10.25 6.1433 9.69035 5.58366 9.00002 5.58366C8.3936 5.58366 7.88802 6.01552 7.77402 6.58847L6.13945 6.26154C6.40533 4.92465 7.58502 3.91699 9.00002 3.91699C10.6109 3.91699 11.9167 5.22283 11.9167 6.83366C11.9167 8.15491 11.0381 9.27099 9.83335 9.62957Z",
    fill: "#6F7376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.a65253d76035d91683d892e89a39a029.svg";
export { ForwardRef as ReactComponent };